import { requester } from "App";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import style from "./VendingDetail.module.css";
import FlexChild from "layouts/flex/FlexChild";

function VendingDetail() {
    const location = useLocation();
    const [value, setValue] = useState(null);
    const [vendorDetails, setVendorDetails] = useState(null);

    useEffect(() => {
        if (location.state && location.state.data) {
            setValue(location.state.data);
            // 예시로 지정한 요청 함수, 실제 애플리케이션에 맞게 수정 필요
            const data = { id: location.state.data.vendorId };
            requester.findByVendorId(data, (result) => {
                setVendorDetails(result.data);
            });
        }
    }, [location]);

    return (
        <div className={style.flexChild}>
            <table className={style.table}>
                
                <tbody>
                    {value && (
                        <>
                            <tr>
                                <td>자판기 ID</td>
                                <td>{value.id}</td>
                            </tr>
                            <tr>
                                <td>자판기 이름</td>
                                <td>{value.vendingName}</td>
                            </tr>
                        </>
                    )}
                    {vendorDetails && (
                        <tr>
                            <td>점주 ID</td>
                            <td>{vendorDetails.userName}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
}

export default VendingDetail;